module.exports = __webpack_public_path__ + "static/media/ini2-90w.cd70e7eb.jpg";